import { ActionController, ActionControllerEventName } from "@g.frame/common.action_controller";
import { FBX_MODEL, Loader, TEXTURE } from "@g.frame/common.loaders";
import { PickingController, PickingControllerEventNames } from "@g.frame/common.picking_controller";
import { ParentEvent, Tween, ViewerModule } from "@g.frame/core";
import { DesktopModule } from "@g.frame/desktop";
import { OculusQuestModule } from "@g.frame/oculus.quest";
import { BoxBufferGeometry, CircleBufferGeometry, Euler, Group, Mesh, MeshBasicMaterial, MeshPhongMaterial, Quaternion, Vector2, Vector3 } from "three";
import PlungerDrag from "./PlungerDrag";
import Water from "./Water";
const syringesConfig = [
    {
        name: 'MODEL_syringe_1',
        needleName: 'Needle_1',
        position: new Vector3(2.9, 0.75, -10.25),
        rotation: new Euler(Math.PI / 2, 0, Math.PI / 2),
        water: {
            size: new Vector2(0.011, 0.01),
            position: new Vector3(0, 0.147, 0),
        },
        needlePosition: 0.155,
    },
    {
        name: 'MODEL_syringe_2',
        needleName: 'Needle_2',
        position: new Vector3(2.9, 0.76, -10.35),
        rotation: new Euler(Math.PI / 2, 0, Math.PI / 2),
        water: {
            size: new Vector2(0.011, 0.01),
            position: new Vector3(0, 0.147, 0),
        },
        needlePosition: 0.155,
    },
    {
        name: 'MODEL_syringe_3',
        needleName: 'Needle_3',
        position: new Vector3(2.9, 0.76, -10.45),
        rotation: new Euler(Math.PI / 2, 0, Math.PI / 2),
        water: {
            size: new Vector2(0.011, 0.01),
            position: new Vector3(0, 0.147, 0),
        },
        needlePosition: 0.155,
    },
    {
        name: 'MODEL_syringe_4',
        needleName: 'Needle_4',
        position: new Vector3(2.9, 0.76, -10.55),
        rotation: new Euler(Math.PI / 2, 0, Math.PI / 2),
        water: {
            size: new Vector2(0.011, 0.01),
            position: new Vector3(0, 0.147, 0),
        },
        needlePosition: 0.155,
    }
];
const needlesConfig = [
    {
        name: 'Needle_1',
        position: new Vector3(2.65, 0.75, -10.25),
        rotation: new Euler(0, -Math.PI / 2, 0),
        offset: 0,
    },
    {
        name: 'Needle_2',
        position: new Vector3(2.65, 0.75, -10.35),
        rotation: new Euler(0, -Math.PI / 2, 0),
        offset: 0,
    },
    {
        name: 'Needle_3',
        position: new Vector3(2.65, 0.75, -10.45),
        rotation: new Euler(0, -Math.PI / 2, 0),
        offset: 0,
    },
    {
        name: 'Needle_4',
        position: new Vector3(2.65, 0.75, -10.55),
        rotation: new Euler(0, -Math.PI / 2, 0),
        offset: 0,
    }
];
const vialsConfig = [
    {
        name: 'MODEL_blue_med_vial',
        position: new Vector3(2.45, 0.7375, -10.325),
        rotation: new Euler(-Math.PI / 2, 0, Math.PI / 2),
    },
    {
        name: 'MODEL_red_med_vial',
        position: new Vector3(2.45, 0.7375, -10.45),
        rotation: new Euler(-Math.PI / 2, 0, Math.PI / 2),
    }
];
const syrMat = {
    'Body003': 'TEXTURE_syringe',
};
const vialRed = {
    'label002': 'TEXTURE_red_vial',
    'cap_top002': 'TEXTURE_red_vial',
};
const vialBlue = {
    'label': 'TEXTURE_blue_vial',
    'cap_top': 'TEXTURE_blue_vial',
};
export default class Syringes extends ViewerModule {
    constructor(modulesProcessor, showUIStep) {
        var _a;
        super();
        this.modulesProcessor = modulesProcessor;
        this.showUIStep = showUIStep;
        this.syringes = {};
        this.needles = {};
        this.syringeParts = {};
        this.vials = {};
        this.loader = this.modulesProcessor.agents.get(Loader);
        this.actionController = this.modulesProcessor.agents.get(ActionController);
        this.pickingController = this.modulesProcessor.agents.get(PickingController);
        this.controls = this.modulesProcessor.modulesInstances.get(DesktopModule)[1];
        this.isVR = !!((_a = this.modulesProcessor.modulesInstances.get(OculusQuestModule)) === null || _a === void 0 ? void 0 : _a.length);
        this.water = new Water();
        this.loader.addResources([
            {
                name: 'MODEL_syringe_1',
                url: require('../../../assets/models/injection/syringes/syringe_1.fbx'),
                type: FBX_MODEL
            },
            {
                name: 'MODEL_syringe_2',
                url: require('../../../assets/models/injection/syringes/syringe_2.fbx'),
                type: FBX_MODEL
            },
            {
                name: 'MODEL_syringe_3',
                url: require('../../../assets/models/injection/syringes/syringe_3.fbx'),
                type: FBX_MODEL
            },
            {
                name: 'MODEL_syringe_4',
                url: require('../../../assets/models/injection/syringes/syringe_4.fbx'),
                type: FBX_MODEL
            },
            {
                name: 'TEXTURE_syringe',
                url: require('../../../assets/textures/injection/syringe_bc.png'),
                type: TEXTURE
            },
            {
                name: 'MODEL_blue_med_vial',
                url: require('../../../assets/models/injection/vials/blue_med_vial.fbx'),
                type: FBX_MODEL
            },
            {
                name: 'MODEL_red_med_vial',
                url: require('../../../assets/models/injection/vials/red_med_vial.fbx'),
                type: FBX_MODEL
            },
            {
                name: 'TEXTURE_red_vial',
                url: require('../../../assets/textures/injection/vial_red.png'),
                type: TEXTURE
            },
            {
                name: 'TEXTURE_blue_vial',
                url: require('../../../assets/textures/injection/vial_blue.png'),
                type: TEXTURE
            }
        ]);
    }
    init() {
        this.initSyringes();
        this.initVials();
    }
    // init
    initSyringes() {
        const syringesContainer = new Group();
        const needlesContainer = new Group();
        this.addObject(syringesContainer);
        this.addObject(needlesContainer);
        syringesConfig.forEach(conf => {
            const model = this.loader.getResource(conf.name);
            model.traverse((child) => {
                if (child.name.includes('Cap')) {
                    child.visible = false;
                }
                if (child.name.includes('Needle')) {
                    this.needles[conf.needleName] = child;
                }
            });
            this.prepareGeometry(model, 0.25);
            model.position.copy(conf.position);
            model.rotation.copy(conf.rotation);
            model.scale.setScalar(1);
            model.userData.water = conf.water;
            model.userData.needlePosition = conf.needlePosition;
            this.syringes[conf.name] = model;
            syringesContainer.add(model);
        });
        this.prepareMaterials(syringesContainer);
        const needleGeo = new BoxBufferGeometry(6, 6, 15);
        const needleMat = new MeshBasicMaterial({ color: '#44ee44', visible: false });
        needlesConfig.forEach((conf) => {
            const model = this.needles[conf.name];
            const nGroup = new Group();
            nGroup.add(model);
            nGroup.position.copy(model.position);
            nGroup.rotation.copy(model.rotation);
            nGroup.scale.copy(model.scale);
            model.position.set(0, 0, 0);
            model.rotation.set(0, 0, 0);
            model.scale.setScalar(1);
            const needleHover = new Mesh(needleGeo, needleMat);
            needleHover.position.z = 6;
            nGroup.add(needleHover);
            nGroup.position.copy(conf.position);
            nGroup.rotation.copy(conf.rotation);
            nGroup.userData.needleOffset = conf.offset;
            nGroup.userData.mainContainer = needlesContainer;
            this.needles[conf.name] = nGroup;
            needlesContainer.add(nGroup);
        });
    }
    initVials() {
        const vialsContainer = new Group();
        this.addObject(vialsContainer);
        vialsConfig.forEach(conf => {
            const model = this.loader.getResource(conf.name);
            this.prepareGeometry(model, 0.02);
            this.prepareVial(model);
            model.position.copy(conf.position);
            model.rotation.copy(conf.rotation);
            model.scale.setScalar(1);
            this.vials[conf.name] = model;
            model.userData.parent = vialsContainer;
            vialsContainer.add(model);
        });
    }
    prepareMaterials(syringesContainer) {
        syringesContainer.traverse((child) => {
            // if(child.material && syrMat[child.name]) {
            if (child.material) {
                child.material = new MeshPhongMaterial({ map: this.loader.getResource(syrMat[child.name]) });
                if (child.name.includes('Body')) {
                    child.material.transparent = true;
                    child.material.opacity = 0.3;
                    child.material.needsUpdate = true;
                }
            }
        });
    }
    prepareVial(vial) {
        const conf = vial.name === 'Red_med' ? vialRed : vialBlue;
        vial.traverse((child) => {
            if (child.name.includes('liquid')) {
                child.material = new MeshBasicMaterial({ transparent: true, opacity: 0.6, color: '#9999ee' });
            }
            if (child.name.includes('bottle')) {
                child.material = new MeshBasicMaterial({ transparent: true, opacity: 0.4 });
            }
            if (child.name.includes('cap_gasket')) {
                child.material = new MeshBasicMaterial({ transparent: true, opacity: 0.6 });
            }
            else if (child.material && conf[child.name]) {
                child.material = new MeshPhongMaterial({ map: this.loader.getResource(conf[child.name]) });
            }
        });
    }
    prepareGeometry(syringesContainer, scale) {
        // const mat = new MeshPhongMaterial();
        syringesContainer.traverse((child) => {
            if (child.geometry) {
                child.geometry.scale(scale, scale, scale);
            }
            child.position.multiplyScalar(scale);
        });
    }
    // reset
    resetStage() {
        clearTimeout(this.timeout);
        this.resetSyringes();
        this.resetVials();
        if (this.water) {
            this.water.updateWater(1);
            this.water.uiObject.visible = false;
        }
    }
    resetSyringes() {
        syringesConfig.forEach(conf => {
            const model = this.syringes[conf.name];
            model.position.copy(conf.position);
            model.rotation.copy(conf.rotation);
        });
        needlesConfig.forEach((conf) => {
            const model = this.needles[conf.name];
            model.position.copy(conf.position);
            model.rotation.copy(conf.rotation);
            model.userData.mainContainer.add(model);
        });
        const lever = this.syringeParts['Lever'];
        if (lever) {
            lever.position.copy(lever.userData.opos);
        }
        if (this.plungerDragComponent) {
            this.plungerDragComponent.removeEvents();
            this.plungerDragComponent.removeDrag();
        }
        for (let key in this.needles) {
            this.pickingController.off(PickingControllerEventNames.PICKED, this.needles[key]);
            this.pickingController.off(PickingControllerEventNames.RELEASED, this.needles[key]);
            this.actionController.off(ActionControllerEventName.click, this.needles[key]);
        }
        for (let key in this.syringes) {
            this.pickingController.off(PickingControllerEventNames.PICKED, this.syringes[key]);
            this.pickingController.off(PickingControllerEventNames.RELEASED, this.syringes[key]);
            this.actionController.off(ActionControllerEventName.click, this.syringes[key]);
        }
    }
    resetVials() {
        vialsConfig.forEach(conf => {
            const model = this.vials[conf.name];
            model.position.copy(conf.position);
            model.rotation.copy(conf.rotation);
        });
        if (this.activeCap) {
            const cap = this.activeCap;
            cap.userData.parent.add(cap);
            cap.position.copy(cap.userData.position);
            cap.rotation.copy(cap.userData.rotation);
            this.activeCap = null;
        }
        if (this.activeVial) {
            this.activeVial.userData.parent.add(this.activeVial);
            this.activeVial = null;
        }
        for (let key in this.vials) {
            this.pickingController.off(PickingControllerEventNames.PICKED, this.vials[key]);
            this.pickingController.off(PickingControllerEventNames.RELEASED, this.vials[key]);
            this.actionController.off(ActionControllerEventName.click, this.vials[key]);
        }
    }
    //
    vialSelectStep() {
        // for(let key in this.vials) {
        //     const vial = this.vials[key];
        //     this.actionController.on(ActionControllerEventName.click, vial, () => {
        //         this.activeVial = vial;
        //         this.pickVial(vial);
        //     });
        // }
        for (let key in this.vials) {
            const vial = this.vials[key];
            vial.userData.pickingMoveDistance = 1.6;
            const dragConfig = {
                object: vial,
                parentPosition: new Vector3,
                drag: {
                    start: {
                        position: vial.position.clone(),
                        rotation: vial.rotation.clone()
                    },
                    end: {
                        position: new Vector3(2.5, 0.74, -11),
                        rotation: new Euler(-Math.PI / 2, 0, Math.PI / 2)
                    },
                    quaternion: new Quaternion().setFromEuler(new Euler(-Math.PI / 2, 0, Math.PI / 2))
                },
            };
            this.dragObject(dragConfig).then(() => {
                this.activeVial = vial;
                this.pickVial(vial);
            });
        }
    }
    pickVial(vial) {
        for (let key in this.vials) {
            this.actionController.off(ActionControllerEventName.click, this.vials[key]);
            this.pickingController.off(PickingControllerEventNames.PICKED, this.vials[key]);
        }
        this.activeVial.userData.o_p = this.activeVial.position.clone();
        this.activeVial.userData.o_r = this.activeVial.rotation.clone();
        // this.objectMove(vial, new Vector3(2.5, 0.74, -11)).then(() => {
        let cap = null;
        this.activeVial.traverse((child) => {
            if (child.name.includes('cap_top')) {
                cap = child;
            }
        });
        cap.userData = {
            parent: vial,
            position: cap.position.clone(),
            rotation: cap.rotation.clone(),
        };
        this.activeCap = cap;
        this.activeVial.parent.add(cap);
        cap.rotation.set(0, 0, 0);
        cap.position.copy(this.activeVial.position).add(new Vector3(0, -0.06, 0.06));
        this.NeedleSelectStep();
        // });
    }
    NeedleSelectStep() {
        this.showUIStep(3);
        for (let key in this.needles) {
            const needle = this.needles[key];
            this.actionController.on(ActionControllerEventName.click, needle, () => {
                this.activeNeedle = needle;
                this.pickNeedle(needle);
            });
        }
    }
    pickNeedle(needle) {
        for (let key in this.needles) {
            this.actionController.off(ActionControllerEventName.click, this.needles[key]);
        }
        this.objectMove(needle, new Vector3(2.55, 0.75, -11.2)).then(() => {
            this.SyringeSelectStep();
        });
    }
    SyringeSelectStep() {
        this.showUIStep(4);
        for (let key in this.syringes) {
            const syringe = this.syringes[key];
            this.actionController.on(ActionControllerEventName.click, syringe, () => {
                this.activeSyringe = syringe;
                this.pickSyringe(syringe);
            });
        }
    }
    pickSyringe(syringe) {
        for (let key in this.syringes) {
            this.actionController.off(ActionControllerEventName.click, this.syringes[key]);
        }
        this.objectMove(syringe, new Vector3(3, 1.3, -11)).then(() => {
            syringe.rotation.set(0, Math.PI / 2, 0);
            this.initInjectionSteps();
        });
    }
    initInjectionSteps() {
        this.showUIStep(5);
        //main syringe setup
        this.syringeParts = {};
        const mainSyringe = this.activeSyringe;
        mainSyringe.traverse((child) => {
            if (child.name.includes('Lever')) {
                child.userData.opos = child.position.clone();
                this.syringeParts['Lever'] = child;
            }
            if (child.name.includes('Body')) {
                this.syringeParts['Body'] = child;
            }
        });
        const needle = this.activeNeedle;
        needle.userData.pickingMoveDistance = 1.1;
        needle.position.set(3, 1.3, -11.325);
        needle.rotation.set(-Math.PI / 2, 0, Math.PI / 2);
        const waterConf = this.activeSyringe.userData.water;
        this.water.init(waterConf.size.clone());
        this.water.uiObject.position.copy(waterConf.position);
        const neddlePos = this.activeSyringe.userData.needlePosition;
        const dragConfig = {
            object: this.activeNeedle,
            parentPosition: new Vector3,
            drag: {
                start: {
                    position: needle.position.clone(),
                    rotation: needle.rotation.clone()
                },
                end: {
                    position: mainSyringe.position.clone().add(new Vector3(0, neddlePos, 0)),
                    rotation: new Euler(-Math.PI / 2, 0, 0)
                },
                quaternion: new Quaternion().setFromEuler(new Euler(-Math.PI / 2, 0, Math.PI / 2)),
            }
        };
        this.dragObject(dragConfig).then(() => {
            this.syringeDragStep();
        });
    }
    syringeDragStep() {
        this.showUIStep(6);
        const vial = this.activeVial;
        vial.position.set(3, 1.35, -11.25);
        const mainSyringe = this.activeSyringe;
        const needle = this.activeNeedle;
        const neddlePos = this.activeSyringe.userData.needlePosition;
        needle.position.set(0, neddlePos, 0);
        needle.rotation.set(-Math.PI / 2, 0, 0);
        mainSyringe.add(needle);
        mainSyringe.userData.pickingMoveDistance = 1.1;
        mainSyringe.children.forEach(child => child.position.y -= 0.26);
        mainSyringe.position.y += 0.26;
        const dragConfig = {
            object: mainSyringe,
            parentPosition: new Vector3,
            drag: {
                start: {
                    position: mainSyringe.position.clone(),
                    rotation: mainSyringe.rotation.clone()
                },
                end: {
                    position: vial.position.clone().add(new Vector3(0, 0, 0)),
                    rotation: new Euler(0, Math.PI / 2, Math.PI)
                },
                quaternion: new Quaternion().setFromEuler(new Euler(0, Math.PI / 2, Math.PI))
            },
        };
        this.dragObject(dragConfig).then(() => {
            mainSyringe.children.forEach(child => child.position.y += 0.26);
            mainSyringe.position.y += 0.35;
            this.animateSyringe();
        });
    }
    animateSyringe() {
        const mainSyringe = this.activeSyringe;
        const startPosition = mainSyringe.position.clone();
        const moveDistance = -0.06 - this.activeNeedle.userData.needleOffset;
        new Tween({ alpha: 0 }).to({ alpha: 1 }, 900)
            .onUpdate((alpha) => { mainSyringe.position.y = startPosition.y + moveDistance * alpha; })
            .onComplete(() => { this.rotateSyringe(); })
            .start();
    }
    rotateSyringe() {
        const newPos = this.activeSyringe.worldToLocal(this.activeVial.position.clone());
        this.activeSyringe.add(this.activeVial);
        this.activeVial.position.copy(newPos);
        this.activeVial.rotation.x = Math.PI / 2;
        const mainSyringe = this.activeSyringe;
        const startPosition = mainSyringe.position.clone();
        const startRotation = mainSyringe.rotation.clone();
        const moveDistance = -0.25;
        const rotation = Math.PI;
        new Tween({ alpha: 0 }).to({ alpha: 1 }, 900)
            .onStart(() => { })
            .onUpdate((alpha) => {
            mainSyringe.position.y = startPosition.y + moveDistance * alpha;
            mainSyringe.rotation.x = startRotation.x + rotation * alpha;
        })
            .onComplete(() => {
            this.plungerDrag();
        })
            .start();
    }
    plungerDrag() {
        this.activeSyringe.add(this.water.uiObject);
        this.water.uiObject.visible = true;
        this.plungerDragComponent = new PlungerDrag(this.activeSyringe, this.syringeParts['Lever'], this.modulesProcessor);
        this.plungerDragComponent.initDrag();
        const syrPlunger = this.syringeParts['Lever'];
        syrPlunger.position.y = 0.015;
        let startPos = syrPlunger.position.y;
        this.plungerDragComponent.on('plunger_move', (event) => {
            const offset = event.data.offset;
            const dragPos = startPos + offset;
            const pos = Math.max(-0.08, Math.min(0.015, dragPos));
            syrPlunger.position.y = pos;
            const scale = (pos - 0.015) / -0.01;
            this.water.updateWater(1 + scale);
            if (pos < -0.079) {
                this.plungerDragComponent.removeEvents();
                this.plungerDragAir();
            }
        });
        this.plungerDragComponent.on('plunger_move_end', (event) => {
            startPos = syrPlunger.position.y;
        });
    }
    plungerDragAir() {
        this.showUIStep(7);
        //vial reset 
        this.activeVial.userData.parent.add(this.activeVial);
        this.activeVial.position.copy(this.activeVial.userData.o_p);
        this.activeVial.rotation.copy(this.activeVial.userData.o_r);
        const syrPlunger = this.syringeParts['Lever'];
        this.plungerDragComponent.initDrag();
        let startPos = syrPlunger.position.y;
        this.plungerDragComponent.on('plunger_move', (event) => {
            const offset = event.data.offset;
            const dragPos = startPos + offset;
            const pos = Math.max(-0.08, Math.min(-0.06, dragPos));
            syrPlunger.position.y = pos;
            const scale = (pos - 0.015) / -0.01;
            this.water.updateWater(1 + scale);
            if (pos > -0.061) {
                this.plungerDragComponent.removeEvents();
                this.showUIStep(8);
                this.objectMove(this.activeSyringe, new Vector3(3.3, 1.63, -12)).then(() => {
                    // this.activeSyringe.rotation.x = Math.PI / 2;
                    this.cowInjection();
                });
            }
        });
        this.plungerDragComponent.on('plunger_move_end', (event) => {
            startPos = syrPlunger.position.y;
        });
    }
    cowInjection() {
        //@ts-ignore
        this.timeout = setTimeout(() => { this.showUIStep(9); }, 5500);
        const mainSyringe = this.activeSyringe;
        mainSyringe.userData.pickingMoveDistance = 1.5;
        const injectionPoint = new Mesh(new CircleBufferGeometry(0.12, 32), new MeshBasicMaterial({ color: '#44ee44', transparent: true, opacity: 0.6, side: 2, depthTest: false, depthWrite: false }));
        injectionPoint.position.set(3.7, 1.35, -12.75);
        injectionPoint.rotation.set(-1, 0, 0);
        this.addObject(injectionPoint);
        const dragConfig = {
            object: mainSyringe,
            parentPosition: new Vector3,
            drag: {
                start: {
                    position: mainSyringe.position.clone(),
                    rotation: mainSyringe.rotation.clone()
                },
                end: {
                    position: injectionPoint.position.clone().add(new Vector3(0, 0.35, 0)),
                    rotation: new Euler(Math.PI, 0, 0)
                },
                quaternion: new Quaternion().setFromEuler(new Euler(Math.PI, 0, 0))
            }
        };
        this.dragObject(dragConfig).then(() => {
            injectionPoint.visible = false;
            this.animateSyringeIntoCow();
        });
    }
    animateSyringeIntoCow() {
        const mainSyringe = this.activeSyringe;
        const startPosition = mainSyringe.position.clone();
        const moveDistance = -0.1 - this.activeNeedle.userData.needleOffset;
        ;
        new Tween({ alpha: 0 }).to({ alpha: 1 }, 900)
            .onStart(() => { })
            .onUpdate((alpha) => {
            mainSyringe.position.y = startPosition.y + moveDistance * alpha;
        })
            .onComplete(() => {
            mainSyringe.rotation.z = 0;
            this.cowInjectionDrag();
        })
            .start();
    }
    cowInjectionDrag() {
        const syrPlunger = this.syringeParts['Lever'];
        this.plungerDragComponent.initDrag();
        let startPos = -syrPlunger.position.y;
        this.plungerDragComponent.on('plunger_move', (event) => {
            const offset = event.data.offset;
            const dragPos = startPos + offset;
            const pos = Math.max(-0.025, Math.min(0.06, dragPos));
            syrPlunger.position.y = -pos;
            const scale = (pos + 0.015) / 0.01;
            this.water.updateWater(1 + scale);
            if (pos < -0.0248) {
                this.water.uiObject.visible = false;
                this.plungerDragComponent.removeEvents();
                this.plungerDragComponent.removeDrag();
                //move out syringe
                this.objectMove(this.activeSyringe, this.activeSyringe.position.clone().add(new Vector3(0, 0.2, 0))).then(() => {
                    //return to table
                    this.objectMove(this.activeSyringe, new Vector3(3, 0.9, -11.2)).then(() => {
                        this.activeSyringe.rotation.set(0, 0, 0);
                        this.removeSyringe();
                    });
                });
            }
        });
        this.plungerDragComponent.on('plunger_move_end', (event) => {
            startPos = -syrPlunger.position.y;
        });
    }
    removeSyringe() {
        this.showUIStep(10);
        // this.activeNeedle.position.set(3, 0.9 + this.activeSyringe.userData.needlePosition, -11.2);
        // this.activeNeedle.rotation.x = -1.57;
        //
        // this.activeNeedle.userData.pickingMoveDistance = 1.5;
        // this.activeNeedle.userData.mainContainer.add(this.activeNeedle);
        // this.addObject(this.activeNeedle);
        const dragConfig = {
            object: this.activeSyringe,
            parentPosition: new Vector3,
            drag: {
                start: {
                    position: this.activeSyringe.position.clone(),
                    rotation: this.activeSyringe.rotation.clone()
                },
                end: {
                    position: new Vector3(3.3, 0.75, -12),
                    rotation: new Euler(0, 0, 0)
                },
                quaternion: new Quaternion().setFromEuler(new Euler(-Math.PI / 2, 0, Math.PI / 2))
            }
        };
        this.dragObject(dragConfig).then(() => {
            this.objectMove(this.activeSyringe, new Vector3(3.2, 0.2, -12));
            // this.objectMove(this.activeNeedle, new Vector3(3.2, 0.3, -12));
            this.fire('syringe_finish', new ParentEvent('syringe_finish'));
        });
    }
    dragObject(config) {
        const worldPos = config.parentPosition;
        const dragInfo = config.drag;
        const object = config.object;
        const startPosition = dragInfo.start.position.clone();
        const startRotation = dragInfo.start.rotation.clone();
        const endPosition = dragInfo.end.position.clone();
        const endPositionWorld = dragInfo.end.position.clone().add(worldPos);
        const endRotation = dragInfo.end.rotation.clone();
        const pickingQuaternion = dragInfo.quaternion.clone();
        let callback, callbackMove;
        return new Promise((resolve) => {
            this.pickingController.on(PickingControllerEventNames.PICKED, object, callback = () => {
                this.pickingController.on(PickingControllerEventNames.MOVED, object, callbackMove = (event) => {
                    if (!this.isVR) {
                        object.quaternion.copy(pickingQuaternion);
                        object.updateMatrixWorld(true);
                    }
                });
                this.pickingController.once(PickingControllerEventNames.RELEASED, object, () => {
                    this.pickingController.off(PickingControllerEventNames.MOVED, object, callbackMove);
                    const pointObject = new Vector3();
                    object.getWorldPosition(pointObject);
                    const distance = endPositionWorld.distanceTo(pointObject);
                    const maxDistance = this.isVR ? 0.6 : 0.4;
                    if (distance < maxDistance) {
                        object.position.copy(endPosition);
                        object.rotation.copy(endRotation);
                        this.pickingController.off(PickingControllerEventNames.PICKED, object, callback);
                        resolve();
                    }
                    else {
                        object.position.copy(startPosition);
                        object.rotation.copy(startRotation);
                    }
                });
            });
        });
    }
    objectMove(object, endPosition) {
        const startPosition = object.position.clone();
        return new Promise((resolve) => {
            new Tween({ alpha: 0 }).to({ alpha: 1 }, 900)
                .onStart(() => { })
                .onUpdate((alpha) => {
                object.position.copy(startPosition.clone().lerp(endPosition, alpha));
            })
                .onComplete(() => {
                resolve();
            })
                .start();
        });
    }
}
